var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUssdIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2812",
    "data-name": "Group 2812",
    transform: "translate(-366 -737)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(366 737)",
    fill: "#fde6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2725",
    "data-name": "Group 2725",
    transform: "translate(-2.85 68.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3500",
    "data-name": "Path 3500",
    d: "M348.253,244.667a.193.193,0,0,1,.03-.2,3.261,3.261,0,0,0,.432-2.7h0a9.1,9.1,0,0,0-.576-1.946.072.072,0,0,1,0-.04l-.635-1.534a.9.9,0,0,0-1.216-.372,1.068,1.068,0,0,0-.392.263.168.168,0,0,1-.069.04.2.2,0,0,1-.119,0,.194.194,0,0,1-.144-.124l-.035-.084a.918.918,0,0,0-1.231-.4,1.062,1.062,0,0,0-.531.457.213.213,0,0,1-.109.1.179.179,0,0,1-.159,0,1.063,1.063,0,0,0-.854,0,1.1,1.1,0,0,0-.382.258.278.278,0,0,1-.084.055.262.262,0,0,1-.109,0,.2.2,0,0,1-.159-.124l-1.489-3.673c-.109-.268-.566-.367-.993-.189-.447.189-.725.591-.62.859L341.3,241.5a.213.213,0,0,1-.06.228.406.406,0,0,1-.059.04.233.233,0,0,1-.174,0,15.816,15.816,0,0,0-2.04-.814,1.44,1.44,0,0,0-.948.03l-.045-.189.065.194a.959.959,0,0,0-.561.531.9.9,0,0,0,.67,1.142,13.237,13.237,0,0,1,3.211,1.489.031.031,0,0,1,.03.025h0a2.8,2.8,0,0,1,.263.337,9.17,9.17,0,0,0,.928,1.152,2.632,2.632,0,0,0,.993.556.437.437,0,0,1,.074.025.224.224,0,0,1,.169.119l.735,1.851,4.417-1.8Z",
    transform: "translate(50.87 451.698)",
    fill: "#d136ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3501",
    "data-name": "Path 3501",
    d: "M92.514,0h2.521a.992.992,0,0,1,.923.923V2.645a.923.923,0,0,1-.923.923H92.514a.992.992,0,0,1-.923-.923V.923A.923.923,0,0,1,92.514,0Z",
    transform: "translate(286.259 676.09)",
    fill: "#d136ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3502",
    "data-name": "Path 3502",
    d: "M228.092,0h-2.482a.943.943,0,0,0-.913.953V2.675a.918.918,0,0,0,.913.928h2.482a.923.923,0,0,0,.943-.928V.953A.943.943,0,0,0,228.092,0Z",
    transform: "translate(158.816 676.091)",
    fill: "#d136ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3503",
    "data-name": "Path 3503",
    d: "M356.994,0h2.521a.992.992,0,0,1,.923.923V2.645a.923.923,0,0,1-.923.923h-2.521a.992.992,0,0,1-.923-.923V.923A.923.923,0,0,1,356.994,0Z",
    transform: "translate(33.031 676.09)",
    fill: "#d136ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3504",
    "data-name": "Path 3504",
    d: "M92.514,117.25h2.521a.992.992,0,0,1,.923.923V119.9a.923.923,0,0,1-.923.923H92.514a.992.992,0,0,1-.923-.923v-1.722A.923.923,0,0,1,92.514,117.25Z",
    transform: "translate(286.259 563.829)",
    fill: "#d136ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3505",
    "data-name": "Path 3505",
    d: "M228.094,117.24h-2.482a.913.913,0,0,0-.913.918v1.722a.894.894,0,0,0,.913.893h2.482a.893.893,0,0,0,.943-.893v-1.722a.913.913,0,0,0-.943-.918Z",
    transform: "translate(158.814 563.84)",
    fill: "#d136ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3506",
    "data-name": "Path 3506",
    d: "M356.994,117.25h2.521a.992.992,0,0,1,.923.923V119.9a.923.923,0,0,1-.923.923h-2.521a.992.992,0,0,1-.923-.923v-1.722A.923.923,0,0,1,356.994,117.25Z",
    transform: "translate(33.031 563.829)",
    fill: "#d136ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3507",
    "data-name": "Path 3507",
    d: "M92.514,233.68h2.521a.992.992,0,0,1,.923.923v1.722a.923.923,0,0,1-.923.923H92.514a.992.992,0,0,1-.923-.923V234.6A.923.923,0,0,1,92.514,233.68Z",
    transform: "translate(286.259 452.352)",
    fill: "#d136ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3508",
    "data-name": "Path 3508",
    d: "M228.094,233.32h-2.482a.913.913,0,0,0-.913.918v1.722h0a.923.923,0,0,0,.913.928h2.482a.923.923,0,0,0,.943-.913v-1.722a.913.913,0,0,0-.943-.933Z",
    transform: "translate(158.814 452.697)",
    fill: "#d136ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUssdIcon);
export default __webpack_public_path__ + "static/media/ussd-icon.495859bb91a82cb435d2fb01257ab485.svg";
export { ForwardRef as ReactComponent };